import { defineMessages } from 'react-intl'

const button = defineMessages({
  continue: {
    id: 'bookingBar:button.continue',
    defaultMessage: 'Continue',
    description: 'Continue button',
  },
  checkAvailability: {
    id: 'bookingBar:button.checkAvailability',
    defaultMessage: 'Check availability',
    description: 'Check availability button',
  },
  editGuests: {
    id: 'bookingBar:button.editGuests',
    defaultMessage: 'Edit guests and dates',
    description: 'Edit guests button',
  },
})

const error = defineMessages({
  tooManyAdults: {
    id: 'bookingBar:error.tooManyAdults',
    defaultMessage: 'Only two adults per room.',
    description:
      'Disclaimer when user clicks + button on picker eexceeding maximum allowed value',
  },
})

const label = defineMessages({
  checkoutOnly: {
    id: 'bookingBar:label.checkoutOnly',
    defaultMessage: 'Checkout only',
    description: 'Date range picker label',
  },
  notAvailable: {
    id: 'bookingBar:label.notAvailable',
    defaultMessage: 'Not available',
    description: 'Date range picker label',
  },
  guests: {
    id: 'bookingBar:label.guests',
    defaultMessage: 'Guests',
    description: 'Guests',
  },
  moreRoomsEmail: {
    id: 'bookingBar:label.moreRoomsEmail',
    defaultMessage:
      'For more rooms [silicahotel@bluelagoon.is](mailto:silicahotel@bluelagoon.is)',
    description: 'More rooms email',
  },
  numberOfRooms: {
    id: 'bookingBar:label.numberOfRooms',
    defaultMessage: 'No. of rooms',
    description: 'Number of rooms to select',
  },
  room: {
    id: 'bookingBar:label.room',
    defaultMessage: 'Room',
    description: 'Room',
  },
  selectArrivalDate: {
    id: 'bookingBar:label.selectArrivalDate',
    defaultMessage: 'Select arrival date',
    description: 'Date range picker label',
  },
  selectDepartureDate: {
    id: 'bookingBar:label.selectDepartureDate',
    defaultMessage: 'Select departure date',
    description: 'Date range picker label',
  },
  pleaseSelect: {
    id: 'bookingBar:label.pleaseSelect',
    defaultMessage: 'Select',
    description: 'Date range picker label when no end date is selected',
  },
})

const menu = defineMessages({
  hotel: {
    id: 'bookingBar:menu.hotel',
    defaultMessage: 'Hotel',
    description: 'Hotel',
  },
  guests: {
    id: 'bookingBar:menu.guests',
    defaultMessage: 'Guests / Rooms',
    description: 'Guests / Rooms',
  },
  checkIn: {
    id: 'bookingBar:menu.checkIn',
    defaultMessage: 'Check in',
    description: 'Check in',
  },
  checkOut: {
    id: 'bookingBar:menu.checkOut',
    defaultMessage: 'Check out',
    description: 'Check out',
  },
  retreat: {
    id: 'bookingBar:menu.retreat',
    defaultMessage: 'The Retreat',
    description: 'Retreat hotel',
  },
  silica: {
    id: 'bookingBar:menu.silica',
    defaultMessage: 'Silica Hotel',
    description: 'Silica hotel',
  },
  guestsInRooms: {
    id: 'bookingBar:menu.guestsInRooms',
    defaultMessage:
      '{guests, plural, one {# guest} other {# guests}}, {rooms, plural, one {# room} other {# rooms}}',
    description: 'Number of rooms and guests',
  },
})

const title = defineMessages({
  selectDestination: {
    id: 'bookingBar:title.selectDestination',
    defaultMessage: 'Select a destination / hotel',
    description: 'Header for hotel mobile popover',
  },
  howManyGuests: {
    id: 'bookingBar:title.howManyGuests',
    defaultMessage: 'How many of you are visiting?',
    description: 'Header for guests mobile popover',
  },
  whatDate: {
    id: 'bookingBar:title.whatDate',
    defaultMessage: 'What date are you visiting?',
    description: 'Header for date range mobile popover',
  },
  openEveryDay: {
    id: 'bookingBar:title.openEveryDay',
    defaultMessage: 'We are open every day of the year',
    description: 'Sub header for date range mobile popover',
  },
})

export const bookingBarMessages = {
  button,
  error,
  label,
  menu,
  title,
}
